import { isNil } from 'ramda';
import React, { ReactNode } from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { useQueryParameters } from '~common/hook/use-query-parameters';

export const QueryRoute: React.FunctionComponent<RouteProps> = ({
  component: Component,
  render,
  ...rest
}) => {
  const values = useQueryParameters<any>();

  return (
    <Route
      {...rest}
      render={(renderProps): ReactNode =>
        isNil(render) ? (
          <Component {...renderProps} {...values} />
        ) : (
          render({ ...renderProps, ...values })
        )
      }
    />
  );
};



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/common/src/route/query-route.tsx